import axios from "axios";

const retryAssignFailJob = (uuid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/serialnumber/api/v1/assign/${uuid}/fail-retry`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default retryAssignFailJob;
